import { render, staticRenderFns } from "./PermissaoForm.vue?vue&type=template&id=67642bb4&"
import script from "./PermissaoForm.vue?vue&type=script&lang=js&"
export * from "./PermissaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports